import { format, parseISO } from 'date-fns';
import { DATE_FORMAT } from '../constants';

export function dateTimeToDate(dateTime: string): string {
  return format(parseISO(dateTime), DATE_FORMAT);
}
